import React, { useState } from "react";
import CustomInfoInput from "../customInfoInput";
import CustomTextArea from "../customTextArea";
import { useDispatch } from "react-redux";
import { sendSubscribeSettings } from "../../../redux/reducer/notificationReducer";

const SubscribetSettings = () => {
  const dispatch = useDispatch();

  const [title_en, setTitle_en] = useState("");
  const [title_ar, setTitle_ar] = useState("");
  const [desc_en, setDesc_en] = useState("");
  const [desc_ar, setDesc_ar] = useState("");
  const [link, setLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const sendSubscriber = () => {
    const data = {
      title_en,
      title_ar,
      desc_en,
      desc_ar,
      link,
    };

    if (!title_en || !title_ar || !desc_en || !desc_ar) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    setIsLoading(true);
    dispatch(sendSubscribeSettings(data))
      .unwrap()
      .then((res) => {
        // console.log("Success:", res);
        setTitle_en("");
        setTitle_ar("");
        setDesc_en("");
        setDesc_ar("");
        setLink("");
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="my-5">
      <div className="flex justify-between my-4 ">
        <h1 className="text-xl font-bold text-black">Subscribet</h1>
        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
          onClick={sendSubscriber}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="text-black group-hover:text-white">
              Sending...
            </span>
          ) : (
            <span className="text-black group-hover:text-white">Submit</span>
          )}
        </button>
      </div>
      <div>
        <form className="max-w-[75%] m-auto flex flex-col gap-6">
          {/* Title */}
          <div className="flex gap-5">
            <div className="flex w-full gap-4">
              <CustomInfoInput
                id="title_en"
                label="Title EN"
                type="text"
                placeholder="Title EN"
                value={title_en}
                onChange={(e) => setTitle_en(e.target.value)}
                icon={<i className="fas fa-map-marked-alt"></i>}
              />
              <CustomInfoInput
                id="title_ar"
                label="Title AR"
                type="text"
                placeholder="Title AR"
                value={title_ar}
                onChange={(e) => setTitle_ar(e.target.value)}
                icon={<i className="fas fa-map-marked-alt"></i>}
              />
            </div>
          </div>

          {/* Description */}
          <div className="flex gap-5">
            <CustomTextArea
              id="desc_en"
              label="Description EN"
              type="text"
              placeholder="Description EN"
              value={desc_en}
              onChange={(e) => setDesc_en(e.target.value)}
              icon={<i className="fas fa-map-marked-alt"></i>}
            />
            <CustomTextArea
              id="desc_ar"
              label="Description AR"
              type="text"
              placeholder="Description AR"
              value={desc_ar}
              onChange={(e) => setDesc_ar(e.target.value)}
              icon={<i className="fas fa-map-marked-alt"></i>}
            />
          </div>

          {/* Link */}
          <div className="flex">
            <CustomInfoInput
              id="link"
              label="Link"
              type="text"
              placeholder="Link"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              icon={<i className="fas fa-map-marked-alt"></i>}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubscribetSettings;
